<template>
    <div class="t-lk-modal__content">
        <div class="t-lk-header-notify-dropdown__mobile" :class="{'_after': isAfter}">
            <div class="t-lk-header-notify-dropdown__head">
                <div class="t-lk-header-notify-dropdown__title">
                    {{ profile.notifications.length > 99 ? '99+' : profile.notifications.length }}
                    {{ $root.staticText.lk.notify }}
                </div>
                <router-link :to="{name: 'lk-notifications'}" class="t-main-head__all t-lk-link">
                    <span>{{ $root.staticText.lk.notifyAll }}</span>
                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.8396 3.93238C5.60815 4.16383 5.60815 4.53908 5.8396 4.77053L9.56918 8.50011L5.8396 12.2297C5.60815 12.4611 5.60815 12.8364 5.8396 13.0678C6.07105 13.2993 6.44631 13.2993 6.67776 13.0678L10.8264 8.91918C11.0579 8.68774 11.0579 8.31248 10.8264 8.08103L6.67776 3.93238C6.44631 3.70093 6.07105 3.70093 5.8396 3.93238Z" fill="#00b0bd"/>
                    </svg>
                </router-link>
            </div>

            <div class="t-lk-header-notify-dropdown__container js-dropdown-notify-mobile">
                <div v-for="item in profile.notifications" class="t-lk-header-notify-dropdown__item">
                    <div class="t-lk-header-notify-dropdown__row">
                        <div class="t-lk-header-notify-dropdown__tag">{{ item.tag }}</div>
                    </div>
                    <div class="t-lk-header-notify-dropdown__name">{{ item.name }}</div>
                    <div class="t-lk-header-notify-dropdown__date">
                        {{ item.date }}
                        <svg class="t-lk-header-notify-dropdown__svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00013 2.53322C6.55028 2.53322 5.15981 3.10917 4.13461 4.13437C3.10941 5.15957 2.53346 6.55004 2.53346 7.99989C2.53346 8.71778 2.67486 9.42864 2.94959 10.0919C3.22431 10.7551 3.62699 11.3578 4.13461 11.8654C4.64224 12.373 5.24488 12.7757 5.90813 13.0504C6.57137 13.3252 7.28224 13.4666 8.00013 13.4666C8.71802 13.4666 9.42889 13.3252 10.0921 13.0504C10.7554 12.7757 11.358 12.373 11.8656 11.8654C12.3733 11.3578 12.7759 10.7551 13.0507 10.0919C13.3254 9.42864 13.4668 8.71778 13.4668 7.99989C13.4668 6.55004 12.8908 5.15957 11.8656 4.13437C10.8404 3.10917 9.44998 2.53322 8.00013 2.53322ZM3.38037 3.38012C4.6056 2.15488 6.26738 1.46655 8.00013 1.46655C9.73288 1.46655 11.3947 2.15488 12.6199 3.38012C13.8451 4.60536 14.5335 6.26714 14.5335 7.99989C14.5335 8.85786 14.3645 9.70742 14.0361 10.5001C13.7078 11.2927 13.2266 12.013 12.6199 12.6196C12.0132 13.2263 11.293 13.7076 10.5003 14.0359C9.70767 14.3642 8.8581 14.5332 8.00013 14.5332C7.14216 14.5332 6.29259 14.3642 5.49993 14.0359C4.70727 13.7076 3.98704 13.2263 3.38037 12.6196C2.77369 12.013 2.29245 11.2927 1.96412 10.5001C1.63579 9.70742 1.4668 8.85786 1.4668 7.99989C1.4668 6.26714 2.15513 4.60536 3.38037 3.38012ZM8.00013 4.79989C8.29468 4.79989 8.53346 5.03867 8.53346 5.33322V7.77897L10.3773 9.62276C10.5855 9.83104 10.5855 10.1687 10.3773 10.377C10.169 10.5853 9.83129 10.5853 9.62301 10.377L7.62301 8.37701C7.52299 8.27699 7.4668 8.14134 7.4668 7.99989V5.33322C7.4668 5.03867 7.70558 4.79989 8.00013 4.79989Z" fill="#C0C0CC"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { mapGetters } from "vuex";

    export default {
        name: "lk-mobile-notify",
        props: ['props'],
        data() {
            return {
                isAfter: true,
                elemDropdown: null,
            }
        },
        computed: {
            ...mapGetters('lk', ['profile']),
        },
        methods: {
            scrollBlock() {
                let end = this.elemDropdown.scrollHeight - this.elemDropdown.clientHeight;
                this.isAfter = this.elemDropdown.scrollTop < end;
            },
        },
        mounted() {
            setTimeout(() => {
                this.elemDropdown = document.querySelector('.js-dropdown-notify-mobile');
                if (this.elemDropdown) {
                    this.scrollBlock();
                    document.querySelector('.js-dropdown-notify-mobile').addEventListener('scroll', this.scrollBlock);
                }

            }, 100);
        },
        beforeDestroy() {
            if (this.elemDropdown) {
                document.querySelector('.js-dropdown-notify-mobile').removeEventListener('scroll', this.scrollBlock);
            }
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/lk-mobile-notify.vue